<template lang="pug">
.language-wrap
  .lang-c(data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
    button.language-btn(type='button')
      img(:src="'/new/img/'+getLanguage+'.png'")
    i.fa-solid.fa-caret-down
  .dropdown-menu.language
    button.language-btn.dropitem(type='button' @click="setLanguage('en')")
      img(src='/new/img/en.png')
    button.language-btn.dropitem(type='button' @click="setLanguage('zh')")
      img(src='/new/img/zh.png')
    button.language-btn.dropitem(type='button' @click="setLanguage('my')")
      img(src='/new/img/my.png')
//- .language-wrap
  .lang-c.nb-lang-toggle
    button.language-btn.nb-lang(type='button' :class="{'show': getLanguage === 'en', 'hide': getLanguage !=='en'}" @click="setLanguage('ph')")
      img(src='/new/img/lang-en.png')
      span EN
    button.language-btn.nb-lang(type='button' :class="{'show': getLanguage === 'ph', 'hide': getLanguage !=='ph'}" @click="setLanguage('en')")
      span PH
      img(src='/new/img/lang-ph.png')
</template>
<script>
export default{
  computed: {
    getLanguage() {
      return this.$store.getters.language || "en";
    },
  },
  methods:{
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload);
      this.showLang = false;
    },
  }
}
</script>